<template>
  <a @click="onClickPhone" v-show="!notfound">
    <div v-if="loading">{{ $t('@auditTrailEventsList/loadingConfirmationSmsLabel') }}</div>
    <div v-else-if="phoneNumber">{{ phoneNumber }}</div>
    <div v-else>{{ phonePrefixHardcode }}**********</div>
    <v-dialog v-model="dialog" persistent max-width="480">
      <v-card>
        <v-card-title class="headline">{{ phoneNumber }}</v-card-title>
        <v-card-text>
          <code class="pa-2">{{ message }}</code>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" class="ma-2" text dark @click="dialog = false">
            {{ $t('@auditTrailEventsList/closePopup') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </a>
</template>

<script>
import { phonePrefixHardcode } from '../utils';

export default {
  props: {
    id: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      dialog: false,
      loading: false,
      phoneNumber: '',
      message: '',
      phonePrefixHardcode,
      notfound: false,
    };
  },

  methods: {
    async onClickPhone() {
      if (this.phoneNumber && this.message) {
        this.dialog = true;
      }

      if (!this.$props.id || this.loading || this.phoneNumber) {
        return;
      }

      try {
        this.loading = true;
        const { data } = await this.$http.get(`/api/customers/sms/${this.$props.id}`);

        this.phoneNumber = data.phone;
        this.message = data.message;
        this.dialog = true;
      } catch (e) {
        if (e.response && e.response.status === 404) {
          this.notfound = true;
          this.message = this.$t(
            '@auditTrailEventsList/notFoundConfirmationSmsNotificationMessage',
          );
          this.dialog = true;
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped></style>
